import React from "react";
import "bulma/css/bulma.min.css";
import { COMBINED_FORECAST_LEGEND } from "./sidepane/CombinedForecast";

// Same pattern as CombinedHazardLegend / NDVILegend -- TiTiler COG, no
// GeoServer GetLegendGraphic to pull an image from.
const CombinedForecastLegend = ({ title }) => (
  <div className="box" style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
    <p className="is-size-7 has-text-weight-semibold">{title}</p>
    {COMBINED_FORECAST_LEGEND.map(({ color, label }) => (
      <div key={color} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <div style={{ width: "14px", height: "14px", backgroundColor: color, border: "1px solid #ccc" }} />
        <span className="is-size-7">{label}</span>
      </div>
    ))}
  </div>
);

export default CombinedForecastLegend;
